import React, { useState } from 'react';
import { Table, Button, Form, Row, Col, Card } from 'react-bootstrap';
import { FaPlus, FaSave, FaTimes, FaTrash } from 'react-icons/fa';
import { toast } from 'react-toastify';
import * as api from '~/Services/Service';

const FORM_VAZIO = {
  data_pasta: '',
  valor: '',
};

const GridChequeBonus = ({ codigoFamilia, chequeBonus, onRecarregar }) => {
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState(FORM_VAZIO);
  const [salvando, setSalvando] = useState(false);

  const handleChange = (campo, valor) => {
    setForm((prev) => ({ ...prev, [campo]: valor }));
  };

  const handleIncluir = async () => {
    setSalvando(true);
    try {
      await api.incluirChequeBonusConfig({
        codigo_familia: codigoFamilia,
        data_pasta: form.data_pasta,
        valor: form.valor !== '' ? Number(form.valor) : null,
      });
      toast.success('Cheque bônus incluído com sucesso!');
      setForm(FORM_VAZIO);
      setShowForm(false);
      onRecarregar();
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao incluir cheque bônus';
      toast.error(msg);
    } finally {
      setSalvando(false);
    }
  };

  const handleExcluir = async (item) => {
    if (!window.confirm(`Excluir cheque bônus da data ${item.data_pasta}?`)) return;
    try {
      await api.excluirChequeBonusConfig({
        codigo_familia: codigoFamilia,
        data_pasta: item.data_pasta,
      });
      toast.success('Cheque bônus excluído!');
      onRecarregar();
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao excluir cheque bônus';
      toast.error(msg);
    }
  };

  return (
    <Card className="mb-3">
      <Card.Header className="d-flex justify-content-between align-items-center py-2">
        <strong>Cheque Bônus</strong>
        <Button
          size="sm"
          variant="outline-primary"
          onClick={() => {
            setForm(FORM_VAZIO);
            setShowForm(true);
          }}
        >
          <FaPlus className="mr-1" /> Incluir
        </Button>
      </Card.Header>
      <Card.Body className="p-0">
        {showForm && (
          <div className="p-3 border-bottom bg-light">
            <Row>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Data Pasta</Form.Label>
                  <Form.Control
                    size="sm"
                    type="date"
                    value={form.data_pasta}
                    onChange={(e) => handleChange('data_pasta', e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Valor</Form.Label>
                  <Form.Control
                    size="sm"
                    type="number"
                    value={form.valor}
                    onChange={(e) => handleChange('valor', e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <div className="mt-2">
              <Button
                size="sm"
                variant="success"
                className="mr-2"
                onClick={handleIncluir}
                disabled={salvando}
              >
                <FaSave className="mr-1" /> Salvar
              </Button>
              <Button
                size="sm"
                variant="secondary"
                onClick={() => setShowForm(false)}
                disabled={salvando}
              >
                <FaTimes className="mr-1" /> Cancelar
              </Button>
            </div>
          </div>
        )}
        <div style={{ maxHeight: 300, overflowY: 'auto' }}>
        <Table striped bordered hover size="sm" className="mb-0">
          <thead>
            <tr>
              <th>Data Pasta</th>
              <th>Valor</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {chequeBonus.length === 0 && (
              <tr>
                <td colSpan={3} className="text-center text-muted">
                  Nenhum cheque bônus cadastrado
                </td>
              </tr>
            )}
            {chequeBonus.map((item) => (
              <tr key={`chequebonus-${item.data_pasta}`}>
                <td>{item.data_pasta ? new Date(item.data_pasta).toLocaleDateString('pt-BR') : ''}</td>
                <td>{item.valor}</td>
                <td>
                  <Button
                    size="sm"
                    variant="outline-danger"
                    title="Excluir"
                    onClick={() => handleExcluir(item)}
                  >
                    <FaTrash />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        </div>
      </Card.Body>
    </Card>
  );
};

export default GridChequeBonus;
